import React from "react";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1768839722927-df0ef3188f6d?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85&fit=crop";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Top meta row */}
        <div className="flex items-center justify-between mb-12 md:mb-20">
          <span className="flourish text-[0.7rem] uppercase tracking-[0.32em]">
            Salt Lake City &middot; Utah
          </span>
          <span className="hidden md:inline text-[0.7rem] uppercase tracking-[0.32em] text-[#475569]">
            Est. Practice — Plaintiff&rsquo;s Litigation
          </span>
        </div>

        {/* Editorial grid: 7/5 */}
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
          {/* Headline block */}
          <div className="col-span-12 lg:col-span-7 kb-reveal">
            <p className="text-overline mb-8">
              <span className="kb-counter mr-2">N&deg; 01</span> An Introduction
            </p>
            <h1 className="font-serif-display font-medium text-[#0f172a] leading-[0.95] tracking-tight text-[3.2rem] sm:text-[4.5rem] lg:text-[6.4rem]">
              Plaintiffs&rsquo;
              <span className="block italic text-[#1a362d]">
                trial counsel.
              </span>
            </h1>

            <div className="mt-10 md:mt-14 flex items-start gap-5 max-w-xl">
              <span className="gold-rule-solid mt-3 flex-shrink-0" />
              <p className="text-[#475569] text-base md:text-lg leading-relaxed">
                Ms. Bollinger is a Utah litigation attorney representing
                senior professionals and whistleblowers in employment matters,
                minority partners in business disputes, and victims of elder
                abuse.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-5">
              <a
                href="#contact"
                data-testid="hero-cta-consult"
                className="btn-primary"
              >
                Request a Consultation
                <ArrowDownRight className="w-4 h-4" strokeWidth={1.6} />
              </a>
              <a
                href="#practice"
                data-testid="hero-cta-practice"
                className="btn-secondary"
              >
                Practice Areas
              </a>
            </div>
          </div>

          {/* Editorial image column */}
          <div className="col-span-12 lg:col-span-5 lg:pl-8 mt-12 lg:mt-0">
            <div className="relative">
              <div className="gold-frame">
                <div className="relative overflow-hidden">
                  <img
                    src={HERO_IMG}
                    alt="Statue of Lady Justice holding the scales of justice"
                    data-testid="hero-image"
                    className="w-full h-[420px] md:h-[560px] object-cover object-center grayscale-[12%] contrast-[1.02]"
                  />
                  <div className="absolute inset-0 hero-vignette pointer-events-none" />
                </div>
              </div>
              {/* Caption / quote */}
              <div className="absolute -left-6 md:-left-12 bottom-8 max-w-[280px] bg-[#fdfbf7] border border-[#bfa15f]/30 px-5 py-4 hidden md:block">
                <p className="font-serif-display italic text-[#0f172a] text-lg leading-snug">
                  &ldquo;Tailored strategy. Dedicated advocacy. Results.&rdquo;
                </p>
                <span className="block mt-2 text-[0.65rem] uppercase tracking-[0.28em] text-[#bfa15f]">
                  &mdash; Practice Tenets
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
